<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <p *ngIf="isLL">
    <mat-form-field>
      <input matInput [patterns]="maskCustomPatterns" [showMaskTyped]="true"
        [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off" class="uppercase-text"
        [mask]="maskLatLL" [placeholder]="'EXTERNAL_IP.LATITUDE'| translate" formControlName="latLL">
      </mat-form-field>
  </p>
  <p *ngIf="isLL">
    <mat-form-field>
      <input matInput [patterns]="maskCustomPatterns" [showMaskTyped]="true"
      [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off" class="uppercase-text"
      [mask]="maskLongLL" [placeholder]="'EXTERNAL_IP.LONGITUDE'| translate" formControlName="longLL">
    </mat-form-field>
  </p>
  <p *ngIf="isUTM">
    <mat-form-field><input matInput [patterns]="maskCustomPatterns" [showMaskTyped]="true"
      [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off" class="uppercase-text"
      [mask]="maskZoneUTM" [placeholder]="'EXTERNAL_IP.ZONE'| translate" formControlName="zoneUTM">
    </mat-form-field>
  </p>
  <p *ngIf="isUTM">
    <mat-form-field><input matInput [patterns]="maskCustomPatterns" [showMaskTyped]="true"
      [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off" class="uppercase-text"
      [mask]="maskEastingUTM" [placeholder]="'EXTERNAL_IP.EASTING'| translate" formControlName="eastingUTM">
    </mat-form-field>
  </p>
  <p *ngIf="isUTM">
    <mat-form-field><input matInput [patterns]="maskCustomPatterns" [showMaskTyped]="true"
      [specialCharacters]="maskSpecialCharacters" [dropSpecialCharacters]="false" autocomplete="off" class="uppercase-text"
      [mask]="maskNorthingUTM" [placeholder]="'EXTERNAL_IP.NORTHING'| translate" formControlName="northingUTM">
    </mat-form-field>
  </p>
  <input style="display: none" type="submit">
</form>
